<ng-template #mainNav>
    <big-nav-main-mobile />
</ng-template>

<ng-template #subMenu>
    <div class="px-6 py-9">
        <big-ui-button
            [buttonStyle]="'none w-full'"
            *transloco="let t; prefix: 'nav'"
            (click)="sidenavService.closeSubnav()">
            <div class="flex items-center w-full gap-2 p-4 font-ci text-primary dark:text-white rounded-lg hover:bg-white">
                <big-icon
                    [icon]="iconAngleLeft"
                    [size]="'w-4'"
                    class="fill-current" />
                <span>{{ t('back') }}</span>
            </div>
        </big-ui-button>
        <h5 class="mt-6 px-2">{{ sidenavService.subnavMenu()?.title }}</h5>
        <ul class="space-y-2">
            @for (sub of sidenavService.subnavMenu()?.children; track $index) {
                <li>
                    <big-ui-link
                        (click)="sidenavService.closeSidenav()"
                        linkClass="none hover:text-primary hover:outline-none focus-visible:outline-none focus-visible:text-primary     font-sans leading-[1.6]"
                        [href]="sub.uri">
                        <div class="py-1 px-2">
                            {{ sub.title }}
                        </div>
                    </big-ui-link>
                </li>
            }
        </ul>
    </div>
</ng-template>

<mat-sidenav-container>
    <mat-sidenav-content>
        <mat-sidenav-container>
            <mat-sidenav-content>
                <ng-content />
            </mat-sidenav-content>
            <mat-sidenav
                #drawer
                id="sidenav-drawer"
                fixedInViewport="true"
                [fixedTopGap]="topGap()"
                position="end"
                mode="over"
                (closedStart)="sidenavService.closeSidenav()"
                [opened]="isOpened()">
                @switch (sidenavService.currentSidenav()) {
                    @case ('nav') {
                        <ng-container [ngTemplateOutlet]="mainNav" />
                    }
                    @case ('search') {
                        <big-search-form
                            class="mt-12 px-6 py-4"
                            [location]="'side-nav'"
                            [clearOnSubmit]="true"
                            (submitted)="sidenavService.closeSidenav()" />
                    }
                    @case ('user') {
                        <big-nav-user />
                    }
                }
            </mat-sidenav>
        </mat-sidenav-container>
    </mat-sidenav-content>
    <mat-sidenav
        #subNav
        id="subnav-drawer"
        fixedInViewport="true"
        [fixedTopGap]="topGap()"
        position="end"
        mode="over"
        [opened]="sidenavService.subnavOpened()">
        <ng-container [ngTemplateOutlet]="subMenu" />
    </mat-sidenav>
</mat-sidenav-container>
